<template>
  <div v-if="hasRedeemableVoucher" class="w-full flex-1-0-auto header-height-top-space">
    <div class="w-full pb-4 xl:pb-6">
      <div class="mb-8 md:px-6 lg:px-8 xl:px-20 xl:mb-12">
        <div class="container">
          <StepNavigation
            :step1="tr('pages.sales.steps.step1')"
            :step2="tr('pages.sales.steps.step2')"
            :step3="tr('pages.sales.steps.step3')"
            :active-step="3"
          />
        </div>
      </div>

      <div id="main-content" class="w-full viewport-gutter">
        <div class="container">
          <div class="space-y-3 text-sm xl:text-lg font-family-portado xl:space-y-6">
            <h1 class="text-3xl font-bold leading-none xl:text-4xl">
              {{ tr('pages.sales.confirmation.title') }}
            </h1>
            <p class="leading-relaxed">
              {{ tr('pages.sales.confirmation.description') }}
              {{ tr('pages.sales.confirmation.descriptionLineTwo') }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="w-full pt-6 pb-16 viewport-gutter xl:pt-16 xl:pb-32">
      <div class="container">
        <div class="flex flex-col-reverse items-center justify-between w-full xl:max-w-5xl xl:flex-row xl:mx-auto xl:space-x-20">
          <div class="w-full max-w-lg">
            <div class="space-y-8">
              <div class="w-full rounded shadow xl:w-full">
                <div class="flex items-center px-5 py-4 space-x-3 bg-white rounded-t">
                  <div class="flex-shrink-0 w-24">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240.435 34.263" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path data-name="Path 245" d="M187.097 28.53c7.928-6.35 13.588-11.788 15.275-14.739a3.322 3.322 0 00.549-3.109c-.739-1.649-3.348-2.15-6.57-1.531a253.2 253.2 0 0143.811-5.824.261.261 0 01.093.51 142.834 142.834 0 00-50.1 28.278.128.128 0 01-.062.029l-9.4 1.631a.126.126 0 01-.095-.227c2.3-1.715 4.474-3.396 6.499-5.018z" fill="#d81e05"/><path data-name="Path 246" d="M184.781 12.019l-.658.181a.126.126 0 00.016.245l3.727.532 6.512.929a.129.129 0 00.073-.012c4.582-2.184 7.638-3.026 8.31-2.073a1.41 1.41 0 01-.072 1.333 5.776 5.776 0 01-.318.635 3.322 3.322 0 00.549-3.109c-.739-1.649-3.348-2.15-6.578-1.529q-.554.124-1.106.25-5.27 1.199-10.455 2.618z" fill="#93282c"/><path d="M112.291 31.273l1.625-.2c1.307-.15 1.495-.358 1.495-3.194V16.4c0-1.912-.559-2.317-1.9-2.547l-1.069-.183v-2.337l7.366-.845v17.388c0 2.957.242 3.093 1.267 3.193l1.809.2v2.516h-10.6zM117.03.938a2.448 2.448 0 00-2.719 2.606 2.738 2.738 0 005.475 0A2.466 2.466 0 00117.03.938zM31.278 31.274v2.512H19.837v-2.51l3.351-.4-2.83-7.824H9.106l-2.9 7.862 3.4.362v2.514H0v-2.511l1.464-.2c1.364-.223 1.676-.964 2.307-2.766L14.586 0h2.571L27.5 27.891c.944 2.691 1.259 2.975 2.461 3.233zm-12.03-11.293L14.787 7.645l-4.55 12.336zM94.1 33.786h11.29v-2.423l-2.76-.332c-.971-.1-1.226-.247-1.226-3.149V16.569l.028-.047a4.6 4.6 0 013.381-1.7 9.118 9.118 0 014.206.97v-5.141a6.665 6.665 0 00-2.171-.369c-2.023 0-3.862 1-5.624 3.045l-.186.216-.458-2.783h-6.656v2.85l1.183.2c1.284.219 1.9.669 1.9 2.632v11.439c0 2.972-.236 3.093-1.49 3.236l-1.413.158v2.512zm-3.756-3.9a7.755 7.755 0 01-3.473.881c-1.422 0-2.368-.587-2.368-3.452V13.86h5.558v-3.1H84.5V5.344h-2.69l-1.442 5.416h-3.539v3.1H80.1v14.064c0 4.265 1.733 6.339 5.3 6.339a11.274 11.274 0 006.129-1.908l.194-.129-1.123-2.463zm-35.238 1.4l-1.333-.213c-1.31-.218-1.894-.65-1.894-2.631V10.76H44.4v2.85l1.181.2c1.284.22 1.895.67 1.895 2.633v12.066l-.064.039a11.385 11.385 0 01-5.553 1.832c-2.556 0-3.8-1.526-3.8-4.664V10.76h-7.446v2.855l1.15.2c1.284.22 1.895.67 1.895 2.633v9.7c0 3.7 1.167 8.114 6.728 8.114 2.6 0 4.868-.956 7.354-3.1l.176-.152.5 2.764h6.687v-2.485zm89.808 2.4a6.667 6.667 0 01-2.833.573 3.62 3.62 0 01-3.83-2.562l-.075-.227-.154.183a7.711 7.711 0 01-6.034 2.606c-5.668 0-6.858-3.447-6.858-6.339 0-5.775 4.758-7.148 12.434-7.491l.127-.006v-2.12c0-3.242-.792-4.448-3.592-4.448a14.758 14.758 0 00-6.35 1.366l-.263.108-.952-2.592.181-.119a15.625 15.625 0 018.164-2.341c5.132 0 7.172 2.435 7.172 7.9v10.87c0 1.729.206 1.878 1.488 2.025l1.374.172v2.446zm-7.222-10.3h-.136c-5.772.133-7.72 1.188-7.72 4.18 0 2.709 1.877 3.278 3.452 3.278a4.07 4.07 0 004.4-4.187v-3.262zm-71.108-3.52c-2.372-.653-4.305-1.343-4.305-3.422 0-1.974 1.493-3.018 4.317-3.018 2.569 0 2.959.682 3.157 1.441l.7 2.689h3.123V11.8a13.7 13.7 0 00-6.715-1.523c-5.271 0-8.677 2.743-8.677 6.987 0 4.369 3.209 5.479 6.271 6.287.211.056 1.12.291 1.36.354 2.413.642 4.368 1.36 4.368 3.711 0 2.888-2.489 3.495-4.577 3.495-3.221 0-3.667-.76-3.889-1.678l-.617-3.125h-3.134v6.272a15.506 15.506 0 007.417 1.682c4.362 0 9.024-1.984 9.024-7.551 0-4.4-3.429-5.636-6.479-6.479-.235-.066-1.133-.307-1.344-.366zm95.23 13.92h10.294v-2.515l-1.761-.252c-1.263-.146-1.489-.4-1.489-3.193V18.4c0-5.384-2.322-8.114-6.9-8.114a10.981 10.981 0 00-7.406 3.065l-.188.163-.34-2.75H147.5v2.885l.98.169c1.284.219 1.895.669 1.895 2.632v11.38c0 2.836-.188 3.044-1.494 3.194l-1.625.2v2.564h10.25v-2.517l-1.446-.209c-1.2-.177-1.283-.388-1.283-3.237v-11.79l.064-.039a11.315 11.315 0 015.64-1.832c2.709 0 3.971 1.455 3.971 4.578v9.344c0 2.59-.1 2.841-1.152 2.977l-1.491.207z" fill="#d81e05"/></svg>
                  </div>
                  <div class="w-px h-3 bg-au_gray-700" />
                  <div class="font-family-portado">
                    {{ tr('pages.sales.confirmation.card.title') }}
                  </div>
                </div>
                <div>
                  <img
                    srcset="~images/austrian/confirmation/confirmation-card2x.jpg 2x, ~images/austrian/confirmation/confirmation-card1x.jpg 1x "
                    src="~images/austrian/confirmation/confirmation-card1x.jpg"
                    class="w-full rounded-b"
                    alt=""
                    role="presentation"
                  >
                </div>
              </div>

              <div class="text-white md:flex ticket">
                <div class="relative flex flex-col flex-1 p-6 pb-4 overflow-hidden md:p-4 bg-au_primary rounded-xl">
                  <div class="flex-1">
                    <div class="w-20 h-4">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 160.243 22.835" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M74.839 20.843l1.083-.135c.871-.1 1-.239 1-2.129v-7.647c0-1.274-.372-1.544-1.263-1.7l-.712-.122V7.553l4.909-.563v11.589c0 1.971.161 2.061.844 2.128l1.206.134v1.677h-7.067zM78 .625a1.632 1.632 0 00-1.812 1.737 1.825 1.825 0 003.649 0A1.644 1.644 0 0078 .625zM20.846 20.843v1.674h-7.625v-1.673l2.234-.269-1.886-5.215h-7.5L4.136 20.6l2.269.241v1.676H0v-1.67l.976-.132c.909-.149 1.117-.643 1.538-1.844L9.721 0h1.713l6.895 18.588c.629 1.793.839 1.983 1.64 2.155zm-8.017-7.527L9.855 5.1l-3.032 8.216zm49.886 9.2h7.525V20.9l-1.84-.219c-.647-.067-.817-.165-.817-2.1v-7.538l.019-.032a3.063 3.063 0 012.254-1.132 6.077 6.077 0 012.8.646V7.1a4.442 4.442 0 00-1.447-.246 4.926 4.926 0 00-3.748 2.029l-.124.144-.305-1.854H62.6v1.9l.788.136c.856.146 1.263.446 1.263 1.754v7.621c0 1.981-.157 2.061-.993 2.157l-.942.105v1.674zm-2.5-2.6a5.169 5.169 0 01-2.315.587c-.947 0-1.578-.391-1.578-2.3V9.237h3.7V7.17h-3.7V3.561h-1.798l-.961 3.61H51.2v2.066h2.18v9.373c0 2.843 1.155 4.225 3.531 4.225A7.514 7.514 0 0061 21.563l.129-.086-.749-1.641zm-23.485.933l-.889-.142c-.873-.145-1.262-.433-1.262-1.754V7.172h-4.987v1.9l.787.135c.856.147 1.263.447 1.263 1.755V19l-.043.026a7.587 7.587 0 01-3.7 1.221c-1.7 0-2.531-1.017-2.531-3.108V7.172H20.4v1.9l.766.132c.856.147 1.263.447 1.263 1.755v6.467c0 2.467.778 5.408 4.484 5.408a7.23 7.23 0 004.9-2.065l.117-.1.335 1.842h4.457v-1.658zm59.855 1.6a4.443 4.443 0 01-1.888.382 2.413 2.413 0 01-2.553-1.707l-.05-.151-.1.122a5.139 5.139 0 01-4.021 1.737c-3.778 0-4.571-2.3-4.571-4.225 0-3.849 3.171-4.764 8.287-4.992h.085V12.2c0-2.161-.528-2.964-2.394-2.964a9.836 9.836 0 00-4.232.91l-.175.072-.634-1.728.121-.079a10.414 10.414 0 015.441-1.56c3.421 0 4.78 1.623 4.78 5.263v7.246c0 1.152.137 1.252.992 1.349l.916.114v1.63zm-4.813-6.862h-.091c-3.847.089-5.145.792-5.145 2.786a2.019 2.019 0 002.3 2.184 2.713 2.713 0 002.935-2.791zM44.376 13.24c-1.581-.435-2.869-.9-2.869-2.281 0-1.316 1-2.011 2.877-2.011 1.712 0 1.972.454 2.1.96l.463 1.792h2.081V7.867a9.134 9.134 0 00-4.475-1.015c-3.513 0-5.783 1.828-5.783 4.656 0 2.911 2.139 3.651 4.18 4.19l.906.236c1.608.428 2.911.906 2.911 2.474 0 1.925-1.659 2.329-3.051 2.329-2.147 0-2.444-.506-2.592-1.118l-.4-2.086h-2.091v4.18a10.334 10.334 0 004.943 1.121c2.907 0 6.014-1.322 6.014-5.032 0-2.931-2.285-3.756-4.318-4.318zm63.468 9.277h6.856v-1.676l-1.173-.168c-.842-.1-.992-.264-.992-2.128V12.26c0-3.588-1.547-5.408-4.6-5.408A7.319 7.319 0 00103 8.9l-.122.1-.226-1.833h-4.345v1.927l.653.112c.856.146 1.263.446 1.263 1.754v7.584c0 1.89-.125 2.029-1 2.129l-1.083.135v1.709h6.831v-1.676l-.964-.139c-.8-.118-.855-.259-.855-2.157v-7.858l.042-.026a7.541 7.541 0 013.759-1.221c1.806 0 2.647.969 2.647 3.051v6.228c0 1.726-.065 1.893-.768 1.984l-.993.138zm52.216-20.3a168.933 168.933 0 00-24.787 2.961 1.792 1.792 0 01.6.695 2.692 2.692 0 01-.354 2.633 20.435 20.435 0 01-3.435 4.019 91.427 91.427 0 01-7.39 6.49c-1.35 1.081-2.8 2.2-4.326 3.344a.084.084 0 00.063.151l6.262-1.087a.086.086 0 00.041-.02 95.2 95.2 0 0133.388-18.846.174.174 0 00-.062-.34zm-30.512 7.051a.086.086 0 00.049-.008 14.724 14.724 0 014.681-1.634 1.616 1.616 0 00.176-1.164c-.227-.651-1.03-.951-2.721-.554-.289.068-.581.125-.871.19h-.005l-.737.167q-3.512.8-6.968 1.744l-.438.121a.084.084 0 00.011.164l2.484.354z" fill="#fff"/></svg>
                    </div>
                    <p class="h-16 text-2xl font-bold font-family-portado">
                      {{ tr('pages.sales.confirmation.card.title') }}
                    </p>
                  </div>

                  <p class="text-xs">
                    {{ tr('pages.sales.confirmation.details.value') }}
                  </p>
                  <p class="pb-4 text-xl font-bold">
                    {{ redeemableVoucher.amount | formatCurrency(redeemableVoucher.currency) }}
                  </p>

                  <p class="max-w-64 text-xxs">
                    {{ tr('pages.sales.confirmation.details.validUntilPhrase', { date:
                      $d(new Date(redeemableVoucher.validUntil), 'short')
                    }) }}
                  </p>

                  <div class="absolute bottom-0 right-0 w-full mr-2 -mb-6 opacity-25 max-w-32">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><switch><g><path d="M12.901 3.566l8.547 10.666 7.885.001h.011A1.772 1.772 0 0 1 31.1 16a1.77 1.77 0 0 1-1.75 1.768h-7.902l-8.547 10.666H9.573l6.272-10.668H7.63L4.96 20.434H1.662L4.557 16l-2.895-4.433H4.96l2.67 2.668h8.215L9.573 3.565h3.328m.432-.9H8l6.272 10.67h-6.27l-2.669-2.668H0L3.482 16 0 21.334h5.333l2.67-2.668h6.27L8 29.334h5.333l8.547-10.666h7.47a2.668 2.668 0 0 0 0-5.335h-7.47L13.333 2.666z" fill="#ffffff" /></g></switch></svg>
                  </div>
                </div>
                <div class="ticket__middle" />
                <div class="p-6 pb-4 space-y-4 md:space-y-0 md:p-4 md:flex md:flex-col md:w-40 bg-au_primary rounded-xl">
                  <div class="md:mt-4">
                    <p class="pb-px leading-none text-xxs">
                      {{ tr('pages.sales.confirmation.details.code') }}
                    </p>
                    <p class="text-base font-bold uppercase" data-testid="voucher-code">
                      {{ redeemableVoucher.code }}
                    </p>
                  </div>

                  <div class="p-4">
                    <img src="~images/austrian/qr/qr-code.png" class="w-full" alt="" role="presentation">
                  </div>

                  <div class="text-center text-xxs">
                    <router-link :to="$i18nTo({ name: 'termsOfUse' })" class="underline hover:no-underline" target="_blank">
                      {{ tr('pages.sales.confirmation.details.terms') }}
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="flex flex-col items-center w-full max-w-lg mb-10 space-y-6 xl:w-1/2 xl:mb-0 xl:mt-2 xl:block md:space-y-12">
            <div>
              <ul class="space-y-4 md:space-y-8 list-checkmark-2 text-au_gray-700">
                <li v-html="tr('pages.sales.buy.cards.point1')" />
                <li v-html="tr('pages.sales.buy.cards.point3')" />
                <li v-html="tr('pages.sales.buy.cards.point4')" />
              </ul>
            </div>

            <div class="relative md:w-full md:max-w-68">
              <Button
                variant="primary"
                :loading="downloadingPdf"
                full-width
                @click.prevent="downloadPdf()"
              >
                {{ tr('pages.sales.confirmation.button.download') }}
              </Button>
            </div>

          </div>
        </div>

        <div class="flex justify-center mt-10 xl:mt-24">
          <Button :href="$i18nTo({ name: 'voucherSaleLanding'})" variant="primary-border">
            {{ tr('pages.sales.confirmation.button.return') }}
          </Button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StepNavigation from '~brand-components/austrian/navigation/step-navigation.vue'
import Button from '~brand-components/austrian/button/button.vue'
import VoucherSaleConfirmation from '~brand-pages/base/voucher-sale-confirmation'

export default VoucherSaleConfirmation.extend({
  components: {
    StepNavigation,
    Button,
  },
})
</script>

<style lang="scss" scoped>
.ticket {
  &__middle {
    position: relative;

    &:before {
      content: "";
      background-image: url("data:image/svg+xml,%3Csvg width='8' height='4' viewBox='0 0 8 4' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='2' cy='2' r='2' fill='white'/%3E%3C/svg%3E%0A");

      @apply block absolute left-0 top-0 w-full h-1 z-10 bg-repeat-x -mt-0.5;
    }
  }
}

@screen md {
.ticket {
  &__middle {
    &:before {
      background-image: url("data:image/svg+xml,%3Csvg width='4' height='8' viewBox='0 0 4 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='2' cy='2' r='2' fill='white'/%3E%3C/svg%3E%0A");

      @apply w-1 h-full bg-repeat-y mt-0 -ml-0.5;
    }
  }
}
}
</style>
